var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBreakpointsStudioTablet = function SvgBreakpointsStudioTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19h-7A1.502 1.502 0 0 1 7 17.5v-11A1.502 1.502 0 0 1 8.5 5h7A1.502 1.502 0 0 1 17 6.5v11a1.502 1.502 0 0 1-1.5 1.5Zm-7-13a.5.5 0 0 0-.5.5v11a.501.501 0 0 0 .5.5h7a.501.501 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5h-7Z",
    fill: "#fff"
  })));
};
export default SvgBreakpointsStudioTablet;